import { Box, type BoxProps } from "@mui/material";
import type { ReactNode } from "react";

interface ResponsiveTableContainerProps {
  children: ReactNode;
  sx?: BoxProps["sx"];
}

/**
 * Wraps a table / DataGrid / wide content surface so it scrolls horizontally
 * inside its own container instead of widening the page on narrow viewports.
 * The dual linear-gradient gives a subtle shadow hint on each edge so users
 * see the surface is scrollable; backgroundAttachment:local makes the hints
 * appear only when content is actually wider than the container.
 */
export default function ResponsiveTableContainer({
  children,
  sx,
}: ResponsiveTableContainerProps) {
  return (
    <Box
      sx={{
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
        maxWidth: "100%",
        background:
          "linear-gradient(90deg, rgba(0,0,0,0.04), transparent 8px), linear-gradient(-90deg, rgba(0,0,0,0.04), transparent 8px)",
        backgroundAttachment: "local",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
